import React from "react";
import moment from "moment";

const ScheduleMonthSelect = ({
  month,
  start_date,
  setNextMonth,
  setPrevMonth,
}) => {
  const renderPrev = () => {
    return (
      <button className="btn btn-light border" onClick={setPrevMonth}>
        <i className="fa fa-chevron-left"></i>
      </button>
    );
  };

  const displayDate = (() => {
    if (month !== undefined && month !== null) {
      const startDateMonth = moment(start_date).month();
      if (month !== startDateMonth) {
        const year = moment(start_date).year();
        return moment().month(month).year(year).date(1);
      }
    }
    const weekEnd = moment(start_date).add(6, 'days');
    const nextMonth = moment(start_date).add(1, 'month').startOf('month');
    if (moment(start_date).isBefore(nextMonth) && weekEnd.isSameOrAfter(nextMonth)) {
      return nextMonth;
    }
    return moment(start_date);
  })();

  return (
    <div className="row align-items-center">
      <div className="col-3">{renderPrev()}</div>
      <div className="col-6 text-center">
        <h2 className="mb-0">
          {displayDate.format("MMM")}{" "}
          <span className="small">{displayDate.format("YYYY")}</span>
        </h2>
      </div>
      <div className="col-3 text-right">
        <button className="btn btn-light border" onClick={setNextMonth}>
          <i className="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default ScheduleMonthSelect;
